<template>
    <div>
        <el-form :inline="true">
            <el-form-item>
                <el-upload accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" action="#" :auto-upload="false" :limit="1" :file-list="excelFileList" :on-change="parseNewData" :on-remove="removeExcel">
                    <el-button size="small" type="primary">批量处理新训制证</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传excel文件，且不超过200行</div>
                </el-upload>
            </el-form-item>
            <el-form-item>
                <el-upload accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" action="#" :auto-upload="false" :limit="1" :file-list="excelFileList" :on-change="parseAppendData" :on-remove="removeExcel">
                    <el-button size="small" type="primary">批量增加复训记录</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传excel文件，且不超过200行</div>
                </el-upload>
            </el-form-item>
            <el-form-item>
                <a href="../../static/template/新训模板.xlsx">新训模板下载</a>
            </el-form-item>
            <el-form-item>
                <a href="../../static/template/复训模板.xlsx">复训模板下载</a>
            </el-form-item>
        </el-form>
        <div v-if="showNewCardList">
            <el-table :data="newCardList" border style="width: 100%">
                <el-table-column fixed prop="number" label="序号" width="80">
                </el-table-column>
                <el-table-column fixed prop="name" label="姓名" width="100">
                </el-table-column>
                <el-table-column fixed prop="status" label="处理状态" width="100">
                </el-table-column>
                <el-table-column prop="gender" label="性别" width="100">
                </el-table-column>
                <el-table-column prop="birthday" label="生日" width="150">
                </el-table-column>
                <el-table-column prop="id_number" label="身份证号" width="200">
                </el-table-column>
                <el-table-column prop="phone" label="手机号码" width="200">
                </el-table-column>
                <el-table-column prop="school" label="毕业院校" width="200">
                </el-table-column>
                <el-table-column prop="major" label="所学专业" width="200">
                </el-table-column>
                <el-table-column prop="score_theory" label="理论成绩" width="100">
                </el-table-column>
                <el-table-column prop="score_practice" label="实作成绩" width="100">
                </el-table-column>
                <el-table-column prop="first_init_time" label="首次领证时间" width="150">
                </el-table-column>
                <el-table-column prop="init_time" label="领证时间" width="150">
                </el-table-column>
                <el-table-column prop="training_type" label="培训类别" width="80">
                </el-table-column>
                <el-table-column prop="organization" label="所属机构" width="350">
                </el-table-column>
            </el-table>
            <div style="margin: 20px">
                <el-button type="primary" @click="processNew()">开始批处理</el-button>
            </div>
        </div>
        <div v-if="showAppendCardList">
            <el-table :data="appendCardList" border style="width: 100%">
                <el-table-column fixed prop="number" label="序号" width="80">
                </el-table-column>
                <el-table-column fixed prop="serial" label="证书号" width="180">
                </el-table-column>
                <el-table-column fixed prop="name" label="姓名" width="100">
                </el-table-column>
                <el-table-column prop="gender" label="性别" width="100">
                </el-table-column>
                <el-table-column prop="id_number" label="身份证号" width="200">
                </el-table-column>
                <el-table-column prop="training_time" label="复训时间" width="200">
                </el-table-column>
                <el-table-column prop="score_theory" label="理论成绩" width="100">
                </el-table-column>
                <el-table-column prop="score_practice" label="实作成绩" width="100">
                </el-table-column>
                <el-table-column label="是否重新制证" width="120">
                    <template slot-scope="scope">
                        <el-checkbox v-model="scope.row.is_reprint" />
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="处理状态" width="100">
                </el-table-column>
            </el-table>
            <div style="margin: 20px">
              <el-button type="primary" @click="processAppend()">开始批处理</el-button>
            </div>
        </div>
    </div>
</template>

<script>
  import XLSX from 'xlsx'
  export default {
    data() {
      return {
        excelFileList: [],
        newCardList: [],
        appendCardList: [],
        showNewCardList: false,
        showAppendCardList: false,
        checked1: false,
        checked2: true,
      }
    },
    methods: {
      parseNewData(file, fileList) {
        // 拿取文件对象
        this.newCardList = []
        console.log(fileList)
        console.log(file)
        let f = file.raw;
        // 用FileReader来读取
        let reader = new FileReader();
        // 重写FileReader上的readAsBinaryString方法
        const rABS = true;
        reader.onload = e => {
          let dataResult = e.target.result;
          if (!rABS) dataResult = new Uint8Array(dataResult);
          const workbook = XLSX.read(dataResult, {
            type: rABS ? 'binary' : 'array',
          });
          // 假设我们的数据在第一个标签
          const firstWorksheet = workbook.Sheets[workbook.SheetNames[0]];
          // XLSX自带了一个工具把导入的数据转成json
          let jsonArr = XLSX.utils.sheet_to_json(firstWorksheet, {
            header: 1
          });
          // 通过自定义的方法处理Json，比如加入state来展示
          jsonArr = jsonArr.splice(2, jsonArr.length)
          const keys = ['number', 'name', 'gender', 'birthday', 'id_number', 'education', 'phone', 'school', 'major', 'professional_title', 'score_theory', 'score_practice', 'first_init_time', 'init_time', 'training_type', 'organization'];
          for (var i = 0; i < jsonArr.length; i++) {
            let obj = jsonArr[i].reduce((accumulator, currentValue, currentIndex, array) => {
              accumulator[keys[currentIndex]] = currentValue;
              return accumulator;
            }, {});
            obj['status'] = '未处理'
            this.newCardList.push(obj)
          }
          console.log(this.newCardList)
          this.showNewCardList = true
        };
        if (rABS) reader.readAsBinaryString(f);
        else reader.readAsArrayBuffer(f);
        return false;
      },
      parseAppendData(file, fileList) {
        // 拿取文件对象
        this.appendCardList = []
        console.log(fileList)
        console.log(file)
        let f = file.raw;
        // 用FileReader来读取
        let reader = new FileReader();
        // 重写FileReader上的readAsBinaryString方法
        const rABS = true;
        reader.onload = e => {
          let dataResult = e.target.result;
          if (!rABS) dataResult = new Uint8Array(dataResult);
          const workbook = XLSX.read(dataResult, {
            type: rABS ? 'binary' : 'array',
          });
          // 假设我们的数据在第一个标签
          const firstWorksheet = workbook.Sheets[workbook.SheetNames[0]];
          // XLSX自带了一个工具把导入的数据转成json
          let jsonArr = XLSX.utils.sheet_to_json(firstWorksheet, {
            header: 1
          });
          // 通过自定义的方法处理Json，比如加入state来展示
          jsonArr = jsonArr.splice(2, jsonArr.length)
          console.log(jsonArr)
          const keys = ['number', 'serial', 'name', 'gender', 'id_number', 'training_time', 'score_theory', 'score_practice', 'is_reprint'];
          for (var i = 0; i < jsonArr.length; i++) {
            let obj = jsonArr[i].reduce((accumulator, currentValue, currentIndex, array) => {
              accumulator[keys[currentIndex]] = currentValue;
              return accumulator;
            }, {});
            obj['status'] = '未处理'
            if (obj['is_reprint'] == '是') {
              obj['is_reprint'] = true
            } else {
              obj['is_reprint'] = false
            }
            if(!obj['serial'].startsWith("XH")) {
              obj['is_reprint'] = true
            }
            this.appendCardList.push(obj)
          }
          console.log(this.appendCardList)
          this.showAppendCardList = true
        };
        if (rABS) reader.readAsBinaryString(f);
        else reader.readAsArrayBuffer(f);
        return false;
      },
      removeExcel(file, fileList) {
        this.newCardList = []
        this.appendCardList = []
        this.showNewCardList = false
        this.showAppendCardList = false
      },
      processNew() {
        let x
        for (x in this.newCardList) {
          let jsondata = {}
          let index = x;
          jsondata["序号"] = this.newCardList[x]["number"]
          jsondata["姓名"] = this.newCardList[x]["name"]
          jsondata["文化程度"] = this.newCardList[x]["education"]
          jsondata["联系电话"] = this.newCardList[x]["phone"]
          jsondata["出生年月"] = this.newCardList[x]["birthday"]
          jsondata["初领日期"] = this.newCardList[x]["first_init_time"]
          jsondata["毕业院校"] = this.newCardList[x]["school"]
          jsondata["考生所在单位名称"] = this.newCardList[x]["organization"]
          jsondata["性别"] = this.newCardList[x]["gender"]
          jsondata["实作成绩"] = this.newCardList[x]["score_practice"]
          jsondata["身份证号"] = this.newCardList[x]["id_number"].replace('x', 'X')
          jsondata["理论成绩"] = this.newCardList[x]["score_theory"]
          jsondata["任教科目"] = "职业健康" //this.newCardList[x]["subject"].replace("(", "（").replace(")", "）")
          jsondata["所学专业"] = this.newCardList[x]["major"]
          jsondata["职称"] = this.newCardList[x]["professional_title"]
          jsondata["领证日期"] = this.newCardList[x]["init_time"]
          jsondata["复训次数"] = 1
          console.log(jsondata)
          this.$http.post('http://120.27.221.176/backend/api/v1/raw_info/', jsondata)
            .then(response => {
              if (response.data.result == "1") {
                this.newCardList[index]['status'] = '已处理'
              } else {
                if (response.data.info.indexOf("Duplicate entry") >= 0) {
                  this.newCardList[index]['status'] = '无需重复上传'
                } else {
                  this.newCardList[index]['status'] = response.data.info
                }
              }
            })
            .catch(error => {
              console.log(error)
              this.newCardList[index]['status'] = '处理失败'
            })
            .finally(() => {

            });
        }
      },
      processAppend() {
        let x
        for (x in this.appendCardList) {
          let id = this.appendCardList[x]['serial'].substring(this.appendCardList[x]['serial'].length - 5)
          let index = x;
          this.$http
            .patch('http://120.27.221.176/backend/api/v1/training/certificate/' + id + '/', null)
            .then(response => {
              console.log(response)
              let rsp = response.data
              if (rsp["person_name"] != this.appendCardList[index]["name"] || rsp["id_number"] != this.appendCardList[index]["id_number"]) {
                this.appendCardList[index]['status'] = "身份信息不匹配"
                return
              }
              let init_time_year = parseInt(rsp["init_time"].substring(0, 4))
              let append_time_year = parseInt(this.appendCardList[index]["training_time"].substring(0, 4))
              let json_data = {
                "person": rsp.person,
                "organization": rsp.organization,
                "score_theory": this.appendCardList[index]["score_theory"],
                "score_practice": this.appendCardList[index]["score_practice"],
                "training_time": this.appendCardList[index]["training_time"].replace('年', '-').replace('月', '-').replace('日', '')
              };
              console.log(id + " init time is " + init_time_year)
              console.log(id + " append time is " + append_time_year)
              let should_count = append_time_year - init_time_year + 1
              let actually_count = 1
              if (rsp["training_record_2"] != null) {
                actually_count = 2
              }
              if (rsp["training_record_3"] != null) {
                actually_count = 3
              }
              console.log(id + " should is " + should_count + " actually is " + actually_count)
              if (should_count > 3) { // 大于3表示复训换证
                this.$http
                .post('http://120.27.221.176/backend/api/v1/training/training_record/', json_data)
                .then(response => {
                  console.log(response)
                  var create_id = response.data.id
                  let jsondata = {}
                  jsondata = {
                    "is_need_sync": true,
                    "card": null,
                    "training_record_1": create_id,
                    "training_record_2": null,
                    "training_record_3": null,
                    "valid_time": String(init_time_year + 6) + rsp["valid_time"].substring(4),
                    "init_time": rsp["valid_time"]
                  }
                  if (!this.appendCardList[x]['serial'].startsWith("XH")) {
                    jsondata["serial"] = "XH510" + id
                    console.log("变更证号，重新打印1")
                  }
                  this.$http
                    .patch('http://120.27.221.176/backend/api/v1/training/certificate/' + id + '/', jsondata)
                    .then(response => {
                      this.appendCardList[index]['status'] = "已处理"
                    })
                    .catch(error => {
                      console.log(error)
                    })
                    .finally(() => {});
                })
                .catch(error => {
                  console.log(error)
                })
                .finally(() => {

                });
              } else {
                if (should_count == actually_count) {
                  if (!this.appendCardList[x]['serial'].startsWith("XH")) {
                    console.log("变更证号，重新打印2")
                    let jsondata1 = {
                      "is_need_sync": true,
                    }
                    jsondata1["serial"] = "XH510" + id
                    this.appendCardList[index]['status'] = "本年度已复训"
                    this.$http
                      .patch('http://120.27.221.176/backend/api/v1/training/certificate/' + id + '/', jsondata1)
                      .then(response => {
                        this.appendCardList[index]['status'] = "已处理"
                      })
                      .catch(error => {
                        console.log(error)
                      })
                      .finally(() => {});
                  }
                } else if (should_count < actually_count) {
                  this.appendCardList[index]['status'] = "复训记录有误"
                } else if ((should_count - actually_count) > 1) {
                  this.appendCardList[index]['status'] = "缺少上年度复训记录"
                } else {
                  this.$http
                    .post('http://120.27.221.176/backend/api/v1/training/training_record/', json_data)
                    .then(response => {
                      console.log(response)
                      var create_id = response.data.id
                      let jsondata = {}
                      if (should_count === 3) {
                        jsondata = {
                          "is_need_sync": true,
                          "card": null,
                          "training_record_3": create_id
                        }
                      } else if (should_count === 2) {
                        jsondata = {
                          "is_need_sync": true,
                          "card": null,
                          "training_record_2": create_id
                        }
                      } else {
                        jsondata = {
                          "is_need_sync": true,
                          "card": null,
                          "training_record_1": create_id
                        }
                      }
                      if (this.appendCardList[index]['is_reprint'] == false) {
                        delete jsondata["card"];
                        delete jsondata["is_need_sync"];
                      }
                      if (!this.appendCardList[x]['serial'].startsWith("XH")) {
                        jsondata["serial"] = "XH510" + id
                        jsondata["is_need_sync"] = true
                      }
                      this.$http
                        .patch('http://120.27.221.176/backend/api/v1/training/certificate/' + id + '/', jsondata)
                        .then(response => {
                          this.appendCardList[index]['status'] = "已处理"
                        })
                        .catch(error => {
                          console.log(error)
                        })
                        .finally(() => {});
                    })
                    .catch(error => {
                      console.log(error)
                    })
                    .finally(() => {

                    });
                }
              }
            })
            .catch(error => {
              this.appendCardList[index]['status'] = error.detail
            })
            .finally(() => {

            });
        }
      }
    },
    mounted: function () {

    }
  }
</script>
<style scoped>
  my-el-dialog {
    border: black;
    box-shadow: 0 0px 1px rgba(0, 0, 0, .3);
  }
</style>



// WEBPACK FOOTER //
// src/components/BatchProcess.vue